<template>
  <div class="health-daily">
    <el-card>
      <div class="menu-box">
        <h2>健康日常管理</h2>
        
        <el-tabs v-model="activeTab" @tab-click="handleTabClick">
          <!-- 运动标签页 -->
          <el-tab-pane name="exercise">
            <span slot="label">
              <i class="el-icon-s-promotion"></i> 运动管理
            </span>
            
            <div class="table-container">
              <el-button type="primary" @click="openExerciseDialog">添加运动</el-button>
              <el-table :data="exerciseList" v-loading="exerciseLoading" style="width: 100%">
                <el-table-column type="index" label="序号" width="60"></el-table-column>
                <el-table-column prop="name" label="运动名称" min-width="150"></el-table-column>
                <el-table-column prop="category" label="分类" width="120">
                  <template slot-scope="scope">
                    {{ getCategoryText(scope.row.category) }}
                  </template>
                </el-table-column>
                <el-table-column prop="description" label="描述" min-width="200" show-overflow-tooltip></el-table-column>
                <el-table-column prop="create_time" label="创建时间" width="180">
                  <template slot-scope="scope">
                    {{ formatDate(scope.row.create_time) }}
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="200" fixed="right">      
                  <template slot-scope="scope">
                    <el-button size="mini" @click="getExerciseDetail(scope.row.id)">详情</el-button>
                    <el-button size="mini" type="primary" @click="editExercise(scope.row)">编辑</el-button>
                    <el-button size="mini" type="danger" @click="deleteExercise(scope.row.id)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>

              <!-- 运动分页 -->
              <el-pagination
                class="pagination"
                @size-change="handleExerciseSizeChange"
                @current-change="handleExercisePageChange"
                :current-page="exerciseQuery.page"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="exerciseQuery.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="exerciseTotal"
              ></el-pagination>
            </div>
          </el-tab-pane>

          <!-- 茶饮标签页 -->
          <el-tab-pane name="tea">
            <span slot="label">
              <i class="el-icon-s-goods"></i> 茶饮管理
            </span>
            
            <div class="table-container">
              <el-button type="primary" @click="openTeaDialog">添加茶饮</el-button>
              <el-table :data="teaList" v-loading="teaLoading" style="width: 100%">
                <el-table-column type="index" label="序号" width="60"></el-table-column>
                <el-table-column prop="name" label="茶饮名称" min-width="150"></el-table-column>
                <el-table-column prop="category" label="分类" width="120">
                  <template slot-scope="scope">
                    {{ getCategoryText(scope.row.category) }}
                  </template>
                </el-table-column>
                <el-table-column prop="description" label="描述" min-width="200" show-overflow-tooltip></el-table-column>
                <el-table-column prop="create_time" label="创建时间" width="180">
                  <template slot-scope="scope">
                    {{ formatDate(scope.row.create_time) }}
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="200" fixed="right">
                  <template slot-scope="scope">
                    <el-button size="mini" @click="getTeaDetail(scope.row.id)">详情</el-button>
                    <el-button size="mini" type="primary" @click="editTea(scope.row)">编辑</el-button>
                    <el-button size="mini" type="danger" @click="deleteTea(scope.row.id)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>

              <!-- 茶饮分页 -->
              <el-pagination
                class="pagination"
                @size-change="handleTeaSizeChange"
                @current-change="handleTeaPageChange"
                :current-page="teaQuery.page"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="teaQuery.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="teaTotal"
              ></el-pagination>
            </div>
          </el-tab-pane>

          <!-- 药物标签页 -->
          <el-tab-pane name="medication">
            <span slot="label">
              <i class="el-icon-s-medical"></i> 药物管理
            </span>
            
            <div class="table-container">
              <el-button type="primary" @click="openMedicationDialog">添加药物</el-button>
              <el-table :data="medicationList" v-loading="medicationLoading" style="width: 100%">
                <el-table-column type="index" label="序号" width="60"></el-table-column>
                <el-table-column prop="name" label="药物名称" min-width="150"></el-table-column>
                <el-table-column prop="category" label="分类" width="120">
                  <template slot-scope="scope">
                    {{ getCategoryText(scope.row.category) }}
                  </template>
                </el-table-column>
                <el-table-column prop="description" label="描述" min-width="200" show-overflow-tooltip></el-table-column>
                <el-table-column prop="create_time" label="创建时间" width="180">
                  <template slot-scope="scope">
                    {{ formatDate(scope.row.create_time) }}
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="200" fixed="right">      
                  <template slot-scope="scope">
                    <el-button size="mini" @click="getMedicationDetail(scope.row.id)">详情</el-button>
                    <el-button size="mini" type="primary" @click="editMedication(scope.row)">编辑</el-button>
                    <el-button size="mini" type="danger" @click="deleteMedication(scope.row.id)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>

              <!-- 药物分页 -->
              <el-pagination
                class="pagination"
                @size-change="handleMedicationSizeChange"
                @current-change="handleMedicationPageChange"
                :current-page="medicationQuery.page"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="medicationQuery.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="medicationTotal"
              ></el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-card>

<!-- 运动编辑对话框 -->
<el-dialog
  :title="exerciseDialogTitle"
  :visible.sync="exerciseDialogVisible"
  width="600px"
>
  <el-form :model="exerciseForm" :rules="exerciseRules" ref="exerciseForm"> 
    <el-form-item label="运动名称" prop="name">
      <el-input v-model="exerciseForm.name" placeholder="请输入运动名称"></el-input>
    </el-form-item>
    <el-form-item label="分类" prop="category">
      <el-select v-model="exerciseForm.category" placeholder="请选择分类">        
        <el-option label="有氧运动" value="aerobic"></el-option>        
        <el-option label="力量训练" value="strength"></el-option>        
        <el-option label="柔韧性训练" value="flexibility"></el-option>    
      </el-select>
    </el-form-item>
    <el-form-item label="描述" prop="description">
      <el-input type="textarea" v-model="exerciseForm.description" placeholder="请输入运动描述" rows="4"></el-input>
    </el-form-item>
    <el-form-item label="益处">
      <el-select v-model="exerciseForm.benefits" multiple placeholder="请选择益处">
        <el-option label="增强心肺功能" value="cardio"></el-option>   
        <el-option label="增强肌肉力量" value="muscle"></el-option>   
        <el-option label="改善柔韧性" value="flexible"></el-option>     
        <el-option label="减轻压力" value="stress"></el-option>
      </el-select>
    </el-form-item>
  </el-form>
  <div slot="footer" class="dialog-footer">
    <el-button @click="exerciseDialogVisible = false">取消</el-button>    
    <el-button type="primary" @click="saveExercise">保存</el-button>      
  </div>
</el-dialog>

<!-- 运动详情对话框 -->
<el-dialog
  title="运动详情"
  :visible.sync="exerciseDetailVisible"
  width="600px"
>
  <el-descriptions :column="1" border>
    <el-descriptions-item label="运动名称">{{ exerciseDetail.name }}</el-descriptions-item>
    <el-descriptions-item label="分类">{{ getCategoryText(exerciseDetail.category) }}</el-descriptions-item>
    <el-descriptions-item label="描述">{{ exerciseDetail.description }}</el-descriptions-item>
    <el-descriptions-item label="益处">
      <el-tag v-for="benefit in exerciseDetail.benefits" :key="benefit" size="small" style="margin-right: 5px;">{{ getBenefitText(benefit) }}</el-tag>      
    </el-descriptions-item>
    <el-descriptions-item label="创建时间">{{ formatDate(exerciseDetail.create_time) }}</el-descriptions-item>
    <el-descriptions-item label="更新时间">{{ formatDate(exerciseDetail.update_time) }}</el-descriptions-item>
  </el-descriptions>
  <div slot="footer" class="dialog-footer">
    <el-button @click="exerciseDetailVisible = false">关闭</el-button>    
  </div>
</el-dialog>

<!-- 茶饮编辑对话框 -->
<el-dialog
  :title="teaDialogTitle"
  :visible.sync="teaDialogVisible"
  width="600px"
>
  <el-form :model="teaForm" :rules="teaRules" ref="teaForm">
    <el-form-item label="茶饮名称" prop="name">
      <el-input v-model="teaForm.name" placeholder="请输入茶饮名称"></el-input>
    </el-form-item>
    <el-form-item label="分类" prop="category">
      <el-select v-model="teaForm.category" placeholder="请选择分类">  
        <el-option label="绿茶" value="green"></el-option>
        <el-option label="红茶" value="black"></el-option>
        <el-option label="花茶" value="flower"></el-option>
        <el-option label="其他" value="other"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="描述" prop="description">
      <el-input type="textarea" v-model="teaForm.description" placeholder="请输入茶饮描述" rows="4"></el-input>
    </el-form-item>
  </el-form>
  <div slot="footer" class="dialog-footer">
    <el-button @click="teaDialogVisible = false">取消</el-button>
    <el-button type="primary" @click="saveTea">保存</el-button>
  </div>
</el-dialog>

<!-- 茶饮详情对话框 -->
<el-dialog
  title="茶饮详情"
  :visible.sync="teaDetailVisible"
  width="600px"
>
  <el-descriptions :column="1" border>
    <el-descriptions-item label="茶饮名称">{{ teaDetail.name }}</el-descriptions-item>
    <el-descriptions-item label="分类">{{ getCategoryText(teaDetail.category) }}</el-descriptions-item>
    <el-descriptions-item label="描述">{{ teaDetail.description }}</el-descriptions-item>
    <el-descriptions-item label="创建时间">{{ formatDate(teaDetail.create_time) }}</el-descriptions-item>
    <el-descriptions-item label="更新时间">{{ formatDate(teaDetail.update_time) }}</el-descriptions-item>
  </el-descriptions>
  <div slot="footer" class="dialog-footer">
    <el-button @click="teaDetailVisible = false">关闭</el-button>
  </div>
</el-dialog>

<!-- 药物编辑对话框 -->
<el-dialog
  :title="medicationDialogTitle"
  :visible.sync="medicationDialogVisible"
  width="600px"
>
  <el-form :model="medicationForm" :rules="medicationRules" ref="medicationForm">
    <el-form-item label="药物名称" prop="name">
      <el-input v-model="medicationForm.name" placeholder="请输入药物名称"></el-input>
    </el-form-item>
    <el-form-item label="分类" prop="category">
      <el-select v-model="medicationForm.category" placeholder="请选择分类">
        <el-option label="西药" value="western"></el-option>
        <el-option label="中药" value="chinese"></el-option>
        <el-option label="保健品" value="health"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="描述" prop="description">
      <el-input type="textarea" v-model="medicationForm.description" placeholder="请输入药物描述" rows="4"></el-input>
    </el-form-item>
  </el-form>
  <div slot="footer" class="dialog-footer">
    <el-button @click="medicationDialogVisible = false">取消</el-button>  
    <el-button type="primary" @click="saveMedication">保存</el-button>    
  </div>
</el-dialog>

<!-- 药物详情对话框 -->
<el-dialog
  title="药物详情"
  :visible.sync="medicationDetailVisible"
  width="600px"
>
  <el-descriptions :column="1" border>
    <el-descriptions-item label="药物名称">{{ medicationDetail.name }}</el-descriptions-item>
    <el-descriptions-item label="分类">{{ getCategoryText(medicationDetail.category) }}</el-descriptions-item>
    <el-descriptions-item label="描述">{{ medicationDetail.description }}</el-descriptions-item>
    <el-descriptions-item label="创建时间">{{ formatDate(medicationDetail.create_time) }}</el-descriptions-item>
    <el-descriptions-item label="更新时间">{{ formatDate(medicationDetail.update_time) }}</el-descriptions-item>
  </el-descriptions>
  <div slot="footer" class="dialog-footer">
    <el-button @click="medicationDetailVisible = false">关闭</el-button>  
  </div>
</el-dialog>
  </div>
</template>

<script>
export default {
  name: 'HealthDaily',
  data() {
    return {
      activeTab: 'exercise',
      exerciseLoading: false,
      exerciseList: [],
      exerciseTotal: 0,
      exerciseQuery: { page: 1, limit: 20, keyword: '', category: '' },
      exerciseDialogVisible: false,
      exerciseDialogTitle: '添加运动',
      exerciseForm: { id: '', name: '', category: '', description: '', benefits: [] },
      exerciseRules: {
        name: [{ required: true, message: '请输入运动名称', trigger: 'blur' }],
        category: [{ required: true, message: '请选择分类', trigger: 'change' }],
        description: [{ required: true, message: '请输入描述', trigger: 'blur' }]
      },
      exerciseDetailVisible: false,
      exerciseDetail: {},
      teaLoading: false,
      teaList: [],
      teaTotal: 0,
      teaQuery: { page: 1, limit: 20, keyword: '', category: '' },
      teaDialogVisible: false,
      teaDialogTitle: '添加茶饮',
      teaForm: { id: '', name: '', category: '', description: '' },
      teaRules: {
        name: [{ required: true, message: '请输入茶饮名称', trigger: 'blur' }],
        category: [{ required: true, message: '请选择分类', trigger: 'change' }],
        description: [{ required: true, message: '请输入描述', trigger: 'blur' }]
      },
      teaDetailVisible: false,
      teaDetail: {},
      medicationLoading: false,
      medicationList: [],
      medicationTotal: 0,
      medicationQuery: { page: 1, limit: 20, keyword: '', category: '' },
      medicationDialogVisible: false,
      medicationDialogTitle: '添加药物',
      medicationForm: { id: '', name: '', category: '', description: '' },
      medicationRules: {
        name: [{ required: true, message: '请输入药物名称', trigger: 'blur' }],
        category: [{ required: true, message: '请选择分类', trigger: 'change' }],
        description: [{ required: true, message: '请输入描述', trigger: 'blur' }]
      },
      medicationDetailVisible: false,
      medicationDetail: {}
    }
  },
  created() { this.getExerciseList() },
  methods: {
    handleTabClick(tab) {
      if (tab.name === 'exercise') this.getExerciseList()
      else if (tab.name === 'tea') this.getTeaList()
      else if (tab.name === 'medication') this.getMedicationList()
    },
    formatDate(timestamp) {
      if (!timestamp) return ''
      const date = new Date(timestamp * 1000)
      return date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0') + ' ' + String(date.getHours()).padStart(2, '0') + ':' + String(date.getMinutes()).padStart(2, '0') + ':' + String(date.getSeconds()).padStart(2, '0')
    },
    getCategoryText(category) {
      const map = { 'aerobic': '有氧运动', 'strength': '力量训练', 'flexibility': '柔韧性训练', 'green': '绿茶', 'black': '红茶', 'flower': '花茶', 'other': '其他', 'western': '西药', 'chinese': '中药', 'health': '保健品' }
      return map[category] || category
    },
    getBenefitText(benefit) {
      const map = { 'cardio': '增强心肺功能', 'muscle': '增强肌肉力量', 'flexible': '改善柔韧性', 'stress': '减轻压力' }
      return map[benefit] || benefit
    },
    async getExerciseList() {
      this.exerciseLoading = true
      try {
        const { data: res } = await this.$axios.post('/admin/edu_youth_health/getExerciseList', this.exerciseQuery)
        if (res.code === 0) { this.exerciseList = res.data.data || []; this.exerciseTotal = res.data.total || 0 }
        else this.$message.error(res.message || '获取运动列表失败')
      } catch (error) { this.$message.error('网络错误，请稍后重试') }
      finally { this.exerciseLoading = false }
    },
    handleExerciseSizeChange(size) { this.exerciseQuery.limit = size; this.getExerciseList() },
    handleExercisePageChange(page) { this.exerciseQuery.page = page; this.getExerciseList() },
    openExerciseDialog() { this.exerciseDialogTitle = '添加运动'; this.exerciseForm = { id: '', name: '', category: '', description: '', benefits: [] }; this.exerciseDialogVisible = true },
    editExercise(row) { this.exerciseDialogTitle = '编辑运动'; this.exerciseForm = { id: row.id, name: row.name, category: row.category, description: row.description, benefits: row.benefits || [] }; this.exerciseDialogVisible = true },
    async saveExercise() {
      this.$refs.exerciseForm.validate(async (valid) => {
        if (valid) {
          try {
            const formData = new FormData()
            formData.append('name', this.exerciseForm.name)
            formData.append('category', this.exerciseForm.category)
            formData.append('description', this.exerciseForm.description)
            if (this.exerciseForm.benefits && this.exerciseForm.benefits.length > 0) formData.append('benefits', JSON.stringify(this.exerciseForm.benefits))
            if (this.exerciseForm.id) formData.append('id', this.exerciseForm.id)
            if (this.exerciseForm.icon && this.exerciseForm.icon instanceof File) formData.append('icon', this.exerciseForm.icon)
            let res = await this.$axios.post(this.exerciseForm.id ? '/admin/edu_youth_health/editExercise' : '/admin/edu_youth_health/addExercise', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            if (res.data.code === 0) { this.$message.success(res.data.message || '操作成功'); this.exerciseDialogVisible = false; this.getExerciseList() }
            else this.$message.error(res.data.message || '操作失败')
          } catch (error) { this.$message.error('网络错误，请稍后重试') }
        }
      })
    },
    async getExerciseDetail(id) {
      try {
        const { data: res } = await this.$axios.post('/admin/edu_youth_health/getExerciseDetail', { id })
        if (res.code === 0) { this.exerciseDetail = res.data; this.exerciseDetailVisible = true }
        else this.$message.error(res.message || '获取详情失败')
      } catch (error) { this.$message.error('网络错误，请稍后重试') }
    },
    async deleteExercise(id) {
      this.$confirm('确定要删除这个运动吗？', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }).then(async () => {
        try {
          const { data: res } = await this.$axios.post('/admin/edu_youth_health/deleteExercise', { id })
          if (res.code === 0) { this.$message.success(res.message || '删除成功'); this.getExerciseList() }
          else this.$message.error(res.message || '删除失败')
        } catch (error) { this.$message.error('网络错误，请稍后重试') }
      }).catch(() => {})
    },
    async getTeaList() {
      this.teaLoading = true
      try {
        const { data: res } = await this.$axios.post('/admin/edu_youth_health/getTeaList', this.teaQuery)
        if (res.code === 0) { this.teaList = res.data.data || []; this.teaTotal = res.data.total || 0 }
        else this.$message.error(res.message || '获取茶饮列表失败')
      } catch (error) { this.$message.error('网络错误，请稍后重试') }
      finally { this.teaLoading = false }
    },
    handleTeaSizeChange(size) { this.teaQuery.limit = size; this.getTeaList() },
    handleTeaPageChange(page) { this.teaQuery.page = page; this.getTeaList() },
    openTeaDialog() { this.teaDialogTitle = '添加茶饮'; this.teaForm = { id: '', name: '', category: '', description: '' }; this.teaDialogVisible = true },
    editTea(row) { this.teaDialogTitle = '编辑茶饮'; this.teaForm = { id: row.id, name: row.name, category: row.category, description: row.description }; this.teaDialogVisible = true },
    async saveTea() {
      this.$refs.teaForm.validate(async (valid) => {
        if (valid) {
          try {
            const formData = new FormData()
            formData.append('name', this.teaForm.name)
            formData.append('category', this.teaForm.category)
            formData.append('description', this.teaForm.description)
            if (this.teaForm.id) formData.append('id', this.teaForm.id)
            if (this.teaForm.icon && this.teaForm.icon instanceof File) formData.append('icon', this.teaForm.icon)
            let res = await this.$axios.post(this.teaForm.id ? '/admin/edu_youth_health/editTea' : '/admin/edu_youth_health/addTea', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            if (res.data.code === 0) { this.$message.success(res.data.message || '操作成功'); this.teaDialogVisible = false; this.getTeaList() }
            else this.$message.error(res.data.message || '操作失败')
          } catch (error) { this.$message.error('网络错误，请稍后重试') }
        }
      })
    },
    async getTeaDetail(id) {
      try {
        const { data: res } = await this.$axios.post('/admin/edu_youth_health/getTeaDetail', { id })
        if (res.code === 0) { this.teaDetail = res.data; this.teaDetailVisible = true }
        else this.$message.error(res.message || '获取详情失败')
      } catch (error) { this.$message.error('网络错误，请稍后重试') }
    },
    async deleteTea(id) {
      this.$confirm('确定要删除这个茶饮吗？', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }).then(async () => {
        try {
          const { data: res } = await this.$axios.post('/admin/edu_youth_health/deleteTea', { id })
          if (res.code === 0) { this.$message.success(res.message || '删除成功'); this.getTeaList() }
          else this.$message.error(res.message || '删除失败')
        } catch (error) { this.$message.error('网络错误，请稍后重试') }
      }).catch(() => {})
    },
    async getMedicationList() {
      this.medicationLoading = true
      try {
        const { data: res } = await this.$axios.post('/admin/edu_youth_health/getMedicationList', this.medicationQuery)
        if (res.code === 0) { this.medicationList = res.data.data || []; this.medicationTotal = res.data.total || 0 }
        else this.$message.error(res.message || '获取药物列表失败')
      } catch (error) { this.$message.error('网络错误，请稍后重试') }
      finally { this.medicationLoading = false }
    },
    handleMedicationSizeChange(size) { this.medicationQuery.limit = size; this.getMedicationList() },
    handleMedicationPageChange(page) { this.medicationQuery.page = page; this.getMedicationList() },
    openMedicationDialog() { this.medicationDialogTitle = '添加药物'; this.medicationForm = { id: '', name: '', category: '', description: '' }; this.medicationDialogVisible = true },
    editMedication(row) { this.medicationDialogTitle = '编辑药物'; this.medicationForm = { id: row.id, name: row.name, category: row.category, description: row.description }; this.medicationDialogVisible = true },
    async saveMedication() {
      this.$refs.medicationForm.validate(async (valid) => {
        if (valid) {
          try {
            const formData = new FormData()
            formData.append('name', this.medicationForm.name)
            formData.append('category', this.medicationForm.category)
            formData.append('description', this.medicationForm.description)
            if (this.medicationForm.id) formData.append('id', this.medicationForm.id)
            if (this.medicationForm.icon && this.medicationForm.icon instanceof File) formData.append('icon', this.medicationForm.icon)
            let res = await this.$axios.post(this.medicationForm.id ? '/admin/edu_youth_health/editMedication' : '/admin/edu_youth_health/addMedication', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            if (res.data.code === 0) { this.$message.success(res.data.message || '操作成功'); this.medicationDialogVisible = false; this.getMedicationList() }
            else this.$message.error(res.data.message || '操作失败')
          } catch (error) { this.$message.error('网络错误，请稍后重试') }
        }
      })
    },
    async getMedicationDetail(id) {
      try {
        const { data: res } = await this.$axios.post('/admin/edu_youth_health/getMedicationDetail', { id })
        if (res.code === 0) { this.medicationDetail = res.data; this.medicationDetailVisible = true }
        else this.$message.error(res.message || '获取详情失败')
      } catch (error) { this.$message.error('网络错误，请稍后重试') }
    },
    async deleteMedication(id) {
      this.$confirm('确定要删除这个药物吗？', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }).then(async () => {
        try {
          const { data: res } = await this.$axios.post('/admin/edu_youth_health/deleteMedication', { id })
          if (res.code === 0) { this.$message.success(res.message || '删除成功'); this.getMedicationList() }
          else this.$message.error(res.message || '删除失败')
        } catch (error) { this.$message.error('网络错误，请稍后重试') }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.health-daily { padding: 20px 0; }
.menu-box h2 { margin-bottom: 30px; font-size: 18px; color: #333; }
.table-container { margin-top: 20px; }
.pagination { margin-top: 20px; text-align: center; }
.el-button { margin-bottom: 15px; }
.el-table { font-size: 13px; }
.el-table-column { min-width: 100px; }
.el-table { overflow-x: auto; width: 100%; }
.el-table__body-wrapper { overflow-x: auto; }
.el-table-column--fixed-right { z-index: 10; }
.el-tabs__content { padding: 0 20px; }
.el-tabs.el-tabs--top { margin-left: 15px; }
@media screen and (max-width: 768px) {
  .menu-box h2 { font-size: 16px; }
  .el-tabs__header { margin-bottom: 15px; }
  .el-tabs__item { font-size: 13px; padding: 0 10px; }
  .el-dialog { width: 95% !important; margin: 20px auto !important; }
  .el-table { font-size: 12px; }
  .el-table-column { min-width: 80px; }
  .el-button { font-size: 12px; padding: 6px 12px; margin-bottom: 10px; }
  .el-input { font-size: 12px; }
  .el-select { font-size: 12px; }
  .pagination { font-size: 12px; }
  .el-pagination__sizes { display: none; }
}
.el-table-column:first-child .cell { padding-left: 20px !important; }
.el-table_1_column_6 .el-table__cell { display: flex; align-items: center; justify-content: center; }
.el-table_1_column_6 .el-table__cell .cell { display: flex; flex-direction: column; align-items: center; gap: 8px; padding: 12px !important; width: 100%; min-height: 110px; justify-content: center; }
.el-table_1_column_6 .el-table__cell .el-button { margin-right: 0 !important; width: 85px; text-align: center; font-size: 12px; padding: 8px 0; border-radius: 4px; height: 32px; display: flex; align-items: center; justify-content: center; }
.el-button.el-button--primary.el-button--mini { margin-bottom: 10px; }
.el-button.el-button--default.el-button--mini { margin-left: 10px; }
@media screen and (max-width: 768px) {
  .el-table-column:first-child .cell { padding-left: 10px !important; }
  .el-table_1_column_6 .el-table__cell .cell { gap: 6px; padding: 8px !important; min-height: 90px; }
  .el-table_1_column_6 .el-table__cell .el-button { width: 75px; font-size: 11px; padding: 6px 0; margin-bottom: 10px; height: 28px; }
}
</style>
